// extracted by mini-css-extract-plugin
module.exports = {"TableSection":"TableSection_TableSection__JR9it","item":"TableSection_item__nH1PV","title":"TableSection_title__KeHGa","description":"TableSection_description__NiHN_"};